// Aweri WhatsApp links (every page; layout/theme.liquid). Shopify's storefront "exit interstitial" (added Oct 2026)
// shows an "Are you sure you want to leave?" page for any http(s) link to a host outside its allow-list, and wa.me is
// not on it. Two facts from that script make this clean: it ignores non-web protocols (whatsapp://), and it stands
// down when the page itself calls preventDefault() on the click. So on PHONES / TABLETS (where the WhatsApp app is),
// a tap on any WhatsApp chat link (wa.me / api.whatsapp.com) or group invite (chat.whatsapp.com) opens the app directly
// with the same number + message (or the same group). If the app did not
// open (the page is still visible ~2.5s later), it falls back to the original link - Shopify's page may show then.
// Desktop is left alone: most desktops have no WhatsApp app, so the normal link (and Shopify's page) is the safe path.
// It covers every WhatsApp chat + group link on the site, including ones the team types into section settings (footer,
// contact, track order, the home community button); business short links and channels stay normal links.
(function () {
  var ua = navigator.userAgent || '';
  var isTouchDevice = /Android|iPhone|iPad|iPod|Mobile/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!isTouchDevice) return;

  // Chats:  wa.me/<number>?text=..  or  api.whatsapp.com/send?phone=<number>&text=..  ->  whatsapp://send?phone=..&text=..
  // Groups: chat.whatsapp.com/<invite code>  ->  whatsapp://chat?code=<code>   (the home "Join on WhatsApp" community)
  // Anything else on WhatsApp (wa.me/message/.. business short links, channels) is left as a normal link.
  function toAppLink(href) {
    var u;
    try { u = new URL(href, location.href); } catch (e) { return null; }
    if (u.hostname === 'chat.whatsapp.com') {
      var code = u.pathname.split('/').filter(Boolean).pop();  // last segment: handles /<code> and the older /invite/<code>
      return code ? 'whatsapp://chat?code=' + encodeURIComponent(code) : null;
    }
    var phone = '';
    if (u.hostname === 'wa.me') {
      if (!/^\/\+?\d+\/?$/.test(u.pathname) && u.pathname !== '/') return null;
      phone = u.pathname.replace(/\D/g, '');
    } else if (u.hostname === 'api.whatsapp.com' || u.hostname === 'web.whatsapp.com') phone = (u.searchParams.get('phone') || '').replace(/\D/g, '');
    else return null;
    var text = u.searchParams.get('text');
    if (!phone && !text) return null;
    var app = 'whatsapp://send?' + (phone ? 'phone=' + phone : '');
    if (text) app += (phone ? '&' : '') + 'text=' + encodeURIComponent(text);
    return app;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var app = toAppLink(a.getAttribute('href'));
    if (!app) return;
    e.preventDefault();
    var fallback = new URL(a.getAttribute('href'), location.href).href;
    var opened = false;
    function onHide() { if (document.visibilityState === 'hidden') opened = true; }
    document.addEventListener('visibilitychange', onHide);
    window.addEventListener('pagehide', function () { opened = true; }, { once: true });
    window.location.href = app;
    setTimeout(function () {
      document.removeEventListener('visibilitychange', onHide);
      if (!opened && document.visibilityState === 'visible') window.location.href = fallback;
    }, 2500);  // long enough for iPhone's 'Open in WhatsApp?' prompt to be answered before falling back
  });
})();
